import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { IconButton } from '@mui/material';

type Props = {
  tabIndex: 0 | -1;
  expanded: boolean;
  disabled: boolean;
  onToggle: () => void;
  openLabel: string;
  closeLabel: string;
};

export const ExpandCell = ({ tabIndex, expanded, disabled, onToggle, openLabel, closeLabel }: Props) => {
  return (
    <IconButton size="small" tabIndex={tabIndex} disabled={disabled} title={expanded ? closeLabel : openLabel} onClick={onToggle}>
      {expanded && <ExpandLess />}
      {!expanded && <ExpandMore />}
    </IconButton>
  );
};
